import { useQuery } from "react-query";
import { getOfficeStatus } from "../../../../../actions/Utilities/OfficeStatus";

export default function useOfficeStatus() {
  return useQuery("GetOfficeStatus", getOfficeStatus, {
    refetchOnWindowFocus: false,
  });
}
